@if (customer(); as customer) {
  <ui-customer-alias (submitResult)="onAliasSubmit($event)" [customer]="customer"></ui-customer-alias>
  <ui-customer-details [customer]="customer"></ui-customer-details>
}
